import type { DropdownOption } from '../types/hrmsAttendanceLeave.types'

export const DEPARTMENT_OPTIONS: DropdownOption[] = [
  { label: 'All Departments', value: '' },
  { label: 'Mathematics', value: 'Mathematics' },
  { label: 'Science', value: 'Science' },
  { label: 'English', value: 'English' },
  { label: 'Computer Science', value: 'Computer Science' },
  { label: 'Administration', value: 'Administration' },
  { label: 'Social Science', value: 'Social Science' },
  { label: 'Physical Education', value: 'Physical Education' },
  { label: 'Languages', value: 'Languages' },
  { label: 'Accounts', value: 'Accounts' },
  { label: 'Library', value: 'Library' },
  { label: 'IT & Support', value: 'IT & Support' },
]

export const AVATAR_COLOR_CLASSES = [
  'bg-teal-100 text-teal-800 border-teal-200',
  'bg-sky-100 text-sky-800 border-sky-200',
  'bg-slate-200 text-slate-800 border-slate-300',
  'bg-emerald-100 text-emerald-800 border-emerald-200',
  'bg-cyan-100 text-cyan-800 border-cyan-200',
  'bg-indigo-100 text-indigo-800 border-indigo-200',
]
